import { graphql, useStaticQuery } from "gatsby";

export const FormCursosAprendizajeQuery = () => {
    const data = useStaticQuery(graphql`
        query contentfulFormCursoAprendizaje {
            form: allContentfulContactenos(
                filter: { contentful_id: { eq: "eaT9YCQPmHYkHXnFKtfHc" } }
            ) {
                nodes {
                    tituloPrincipal
                    descripcionFormulario {
                        raw
                    }
                    descripcion {
                        raw
                    }
                    metaTitulo
                    tituloFormulario
                    titulosFormulario {
                        contentful_id
                        tituloGeneral
                        descripcion {
                            raw
                        }
                        referenciaFormulario {
                            tipoCampo
                            listaSelect
                            mensajeError
                            inputPrincipal
                            nombreId
                            tituloBotonTerminos
                            textoTerminos {
                                raw
                            }
                            obligatorio
                            seccion
                            icon {
                                title
                                file {
                                    url
                                    fileName
                                }
                            }
                            iconDark {
                                title
                                file {
                                    url
                                    fileName
                                }
                            }
                        }
                        tituloBoton
                    }
                }
            }
            modalSuccess: allContentfulContactenos(
                filter: { contentful_id: {eq: "72ZmxvWsmue47TYKh64950"}}
            ) {
                nodes {
                    tituloPrincipal
                    descripcionFormulario {
                        raw
                    }
                    descripcion {
                        raw
                    }
                    metaTitulo
                    imagenFormulario {
                        file {
                            url
                        }
                    }
                    tituloBoton
                    redireccionBoton
                    contentful_id
                }
            }
            modalNointerest: allContentfulContactenos(
                filter: { contentful_id: {eq: "3MOZCpfdCH2F1NooOt8CcY"}}
            ) {
                nodes {
                    tituloPrincipal
                    descripcionFormulario {
                        raw
                    }
                    descripcion {
                        raw
                    }
                    metaTitulo
                    imagenFormulario {
                        file {
                            url
                        }
                    }
                    tituloBoton
                    redireccionBoton
                    contentful_id
                }
            }
        }
    `);
    return data;
}